"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuccessFlags = exports.LinkPosition = exports.EventActions = exports.ErrorTypeOption = exports.notifyFriendlyName = exports.PageUrls = exports.CheckoutLinkNames = exports.EventTypesCodes = void 0;
var StateProvider_1 = require("./StateProvider");
var ReportingHelperService_1 = require("./ReportingHelperService");
var ReportingGateway_1 = require("./ReportingGateway");
var wlsUtils = require("../utils/WirelessUtilFunctions");
var Utils = require("../utils/UtilityFunctions");
var ReportingService = /** @class */ (function (_super) {
    __extends(ReportingService, _super);
    function ReportingService() {
        var _this = _super.call(this) || this;
        // tslint:disable-next-line: no-any
        _this.sendImpressionEvent = function (additionalData) {
            var analyticsEvent = {
                additionalData: additionalData,
                eventAction: EventActions.IMPRESSION,
                eventCode: EventActions.IMPRESSION,
            };
            ReportingGateway_1.default.sendReportingEvent(analyticsEvent);
        };
        _this.stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        return _this;
    }
    ReportingService.prototype.fireLinkClickEvent = function (linkNameValue, linkUrlValue) {
        var subPanelPos = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            subPanelPos[_i - 2] = arguments[_i];
        }
        var linkPosition = this.getLinkPosition(linkNameValue, linkUrlValue, subPanelPos);
        this.firePageLoadEvent(linkUrlValue);
        this.fireLinkClickWithOutPageLoad(linkNameValue, linkUrlValue, linkPosition);
    };
    ReportingService.prototype.fireLinkClickThenPageloadEvent = function (linkNameValue, linkUrlValue) {
        var subPanelPos = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            subPanelPos[_i - 2] = arguments[_i];
        }
        var linkPosition = this.getLinkPosition(linkNameValue, linkUrlValue, subPanelPos);
        this.fireLinkClickWithOutPageLoad(linkNameValue, linkUrlValue, linkPosition);
        this.firePageLoadEvent(linkUrlValue);
    };
    ReportingService.prototype.fireLinkClickWithOutPageLoad = function (linkNameValue, linkUrlValue, linkPosition) {
        var appAnalyticsEvent = {
            additionalData: __assign({ linkDestinationUrl: this.constructFullUrl((linkUrlValue &&
                    linkUrlValue.includes('/buy/checkout') &&
                    !linkUrlValue.includes('/modal')) ? '/buy/checkout/checkoutview' : linkUrlValue), linkName: linkNameValue, linkPosition: linkPosition || this.getLinkPosition(linkNameValue, linkUrlValue, []) }, this.getFlowCodeAndproductType()),
            eventAction: EventActions.LINK_CLICK,
            eventCode: EventTypesCodes.LINK_CLICK_EVENT_CODE,
        };
        ReportingGateway_1.default.sendReportingEvent(appAnalyticsEvent);
    };
    ReportingService.prototype.fireLinkClickWithOutDestination = function (linkNameValue) {
        var appAnalyticsEvent = {
            additionalData: __assign({ linkName: linkNameValue, linkPosition: LinkPosition.BODY }, this.getFlowCodeAndproductType()),
            eventAction: EventActions.LINK_CLICK,
            eventCode: EventTypesCodes.LINK_CLICK_EVENT_CODE,
        };
        ReportingGateway_1.default.sendReportingEvent(appAnalyticsEvent);
    };
    ReportingService.prototype.firePageLoadEvent = function (urlVal, forceTrigger, pageTriggerMethod) {
        var unauthAccess = Utils.unauthenticatedAccess();
        var pageUrl = unauthAccess ? '/buy/cart/savedcartmasked' : urlVal;
        if (!this.isSamePage(urlVal) || forceTrigger) {
            var appAnalyticsEvent = {
                additionalData: __assign(__assign({ url: pageUrl }, this.additionalPageLoadData(pageTriggerMethod, urlVal)), this.getfriendlyPageName(unauthAccess)),
                eventAction: EventActions.PAGE_LOAD,
                eventCode: EventTypesCodes.PAGE_LOAD_EVENT_CODE,
            };
            ReportingGateway_1.default.sendReportingEvent(appAnalyticsEvent);
        }
    };
    ReportingService.prototype.firePromoCodeSubmitEvent = function (promoCodeVal, errorInResponse, errorId, eventTypeParam, isApply, linkName, errorMsg) {
        var appAnalyticsEvent = {
            additionalData: __assign(__assign({}, this.getFormatedAdditionalDetails(errorInResponse, errorId, this.constructFullUrl(PageUrls.PROMO_SUB_PAGE), linkName, errorInResponse ? ErrorTypeOption.Failure_System : ErrorTypeOption.Success_Admit, errorMsg)), { promoCode: promoCodeVal }),
            eventAction: this.getNewEventAction(eventTypeParam),
            eventCode: isApply ? 'DS_Cart_Promo_Code_Submit' : 'DS_Cart_Promo_Code_Remove_Submit',
        };
        ReportingGateway_1.default.sendReportingEvent(appAnalyticsEvent);
    };
    ReportingService.prototype.fireRepCodeSubmitOrRemoveEvent = function (repCodeVal, errorInResponse, errorId, eventTypeParam, isApply, btntext, errorMsg) {
        var appAnalyticsEvent = {
            additionalData: __assign(__assign({}, this.getFormatedAdditionalDetails(errorInResponse, errorId, this.constructFullUrl(PageUrls.REP_SUB_PAGE), btntext, errorInResponse ? ErrorTypeOption.Failure_System : ErrorTypeOption.Success_Admit, errorMsg)), { repCode: repCodeVal }),
            eventAction: this.getNewEventAction(eventTypeParam),
            eventCode: isApply ? 'DS_Cart_Sales_Rep_Code_Submit' : 'DS_Cart_Sales_Rep_Code_Remove_Submit',
        };
        ReportingGateway_1.default.sendReportingEvent(appAnalyticsEvent);
    };
    ReportingService.prototype.fireZipCodeValidateEvent = function (errorInResponse, errorId, errorMsg, linkName, eventTypeParam, linkDUrl) {
        var linkDUrls = linkDUrl ? linkDUrl : PageUrls.CART;
        var appAnalyticsEvent = {
            additionalData: __assign({}, this.getFormatedAdditionalDetails(errorInResponse, errorId, this.constructFullUrl(linkDUrls), linkName, errorInResponse ? ErrorTypeOption.Failure_User : ErrorTypeOption.Success_Admit, errorMsg)),
            eventAction: this.getNewEventAction(eventTypeParam),
            eventCode: 'DS_ZipCode_Submit',
        };
        ReportingGateway_1.default.sendReportingEvent(appAnalyticsEvent);
    };
    ReportingService.prototype.fireCartSummaryDisplay = function (insuranceDetails) {
        var appAnalyticsEvent = {
            additionalData: __assign(__assign(__assign(__assign(__assign(__assign(__assign({}, this.getRetrievedCartFlag()), this.getACPCartFlag()), { errorType: ErrorTypeOption.Success_Admit, statusCode: '0', statusMessage: 'success', successFlag: SuccessFlags.SUCCESSFUL }), this.getFlowCodeAndproductType(PageUrls.CART)), this.getCartItemDetails(EventTypesCodes.SYSTEM_EVENT)), { esimOrderFlag: (wlsUtils.isBYODAndEsim() || wlsUtils.isEsimFlow()) ? 1 : 0, existingItems: insuranceDetails || '', simSwapFlag: (wlsUtils.isSimSwapFlag()) ? 1 : 0 }), this.isAccountLock()),
            eventAction: this.getNewEventAction(EventTypesCodes.SYSTEM_EVENT),
            eventCode: 'DS_System_Cart_Summary_Display',
        };
        ReportingGateway_1.default.sendReportingEvent(appAnalyticsEvent);
    };
    ReportingService.prototype.fireRetrieveCartDisplay = function () {
        var appAnalyticsEvent = {
            additionalData: __assign(__assign(__assign({}, this.getRetrievedCartFlag()), { errorType: ErrorTypeOption.Success_Admit, statusCode: '0', statusMessage: 'success', successFlag: SuccessFlags.SUCCESSFUL }), this.getFlowCodeAndproductType()),
            eventAction: this.getNewEventAction(EventTypesCodes.SYSTEM_EVENT),
            eventCode: 'DS_System_Retrieve_Cart_Display',
        };
        ReportingGateway_1.default.sendReportingEvent(appAnalyticsEvent);
    };
    ReportingService.prototype.fireRetrieveCartResponseEvent = function (errorInResponse, errorMsg, errorId, eventTypeParam, linkName, emailValue, cartOrderSource, cartOriginatingSystem) {
        var appAnalyticsEvent = {
            additionalData: __assign({ email: emailValue }, this.getFormatedAdditionalDetails(errorInResponse, errorId, this.constructFullUrl(PageUrls.RETRIEVE_CART_URL), linkName, errorInResponse ? ErrorTypeOption.Failure_System : ErrorTypeOption.Success_Admit, errorMsg)),
            eventAction: this.getNewEventAction(eventTypeParam),
            eventCode: 'DS_Retrieve_Cart_Submit',
        };
        ReportingGateway_1.default.sendReportingEvent(appAnalyticsEvent);
    };
    ReportingService.prototype.fireCartUpdateSubmitEvent = function (errorInResponse, errorId, eventTypeParam, linkName, errorMsg, linkDUrl, isPostpaidToPrepaid, tradeinReportingData) {
        var appAnalyticsEvent = {
            additionalData: __assign(__assign({}, this.getFormatedAdditionalDetails(errorInResponse, errorId, this.constructFullUrl(linkDUrl), linkName, errorInResponse ? ErrorTypeOption.Failure_System : ErrorTypeOption.Success_Admit, errorMsg)), this.getCartItemDetails(eventTypeParam)),
            eventAction: this.getNewEventAction(eventTypeParam),
            eventCode: tradeinReportingData ? EventTypesCodes.TRADEIN_REPORTING_EVENT :
                EventTypesCodes.CART_UPDATE_IN_CHECKOUT_SUBMIT_EVENT,
        };
        if (isPostpaidToPrepaid) {
            appAnalyticsEvent.additionalData = __assign(__assign({}, appAnalyticsEvent.additionalData), { offerTypeFlag: '1' });
        }
        if (tradeinReportingData) {
            appAnalyticsEvent.additionalData = __assign(__assign({}, appAnalyticsEvent.additionalData), { tradeInDeviceCapacity: tradeinReportingData.tradeInDeviceCapacity, tradeInDeviceCondition: tradeinReportingData.tradeInDeviceCondition, tradeInDeviceMake: tradeinReportingData.tradeInDeviceMake, tradeInDeviceModel: tradeinReportingData.tradeInDeviceModel, tradeInFlag: tradeinReportingData.tradeInFlag, tradeInValue: tradeinReportingData.tradeInValue });
        }
        ReportingGateway_1.default.sendReportingEvent(appAnalyticsEvent);
    };
    ReportingService.prototype.fireSaveCartSubmitEvent = function (errorInResponse, errorMsg, errorId, eventTypeParam, linkName, emailAddress) {
        var appAnalyticsEvent = {
            additionalData: __assign(__assign({ emailAddress: emailAddress }, this.getFormatedAdditionalDetails(errorInResponse, errorId, this.constructFullUrl(PageUrls.SAVE_CART_URL), linkName, errorInResponse ? ErrorTypeOption.Failure_System : ErrorTypeOption.Success_Admit, errorMsg)), this.getCartItemDetails(eventTypeParam)),
            eventAction: this.getNewEventAction(eventTypeParam),
            eventCode: 'DS_Save_Cart_Submit',
        };
        ReportingGateway_1.default.sendReportingEvent(appAnalyticsEvent);
    };
    ReportingService.prototype.reportSystemEventForSelectedAction = function (errorInResponse, errorId, linkNameTxt, eventCodeTxt, selPageUrl, selEventType, errorMsg, itemsArray, linkPos) {
        if (eventCodeTxt === EventTypesCodes.NUMBER_SELECTION_SUBMIT_USER_ACTION) {
            var appAnalyticsEvent = {
                additionalData: __assign(__assign({}, this.getFormatedAdditionalDetails(errorInResponse, errorId, this.constructFullUrl(selPageUrl), linkNameTxt, errorInResponse ? ErrorTypeOption.Failure_System : ErrorTypeOption.Success_Admit, errorMsg, null, linkPos)), { items: itemsArray }),
                eventAction: this.getNewEventAction(selEventType),
                eventCode: eventCodeTxt,
            };
            ReportingGateway_1.default.sendReportingEvent(appAnalyticsEvent);
        }
        else {
            // tslint:disable-next-line: no-any
            var appAnalyticsEvent = {
                additionalData: __assign(__assign({}, this.getFormatedAdditionalDetails(errorInResponse, errorId, this.constructFullUrl(selPageUrl), linkNameTxt, errorInResponse ? ErrorTypeOption.Failure_System : ErrorTypeOption.Success_Admit, errorMsg, undefined, linkPos)), this.getCartItemDetails(selEventType)),
                eventAction: this.getNewEventAction(selEventType),
                eventCode: eventCodeTxt,
            };
            ReportingGateway_1.default.sendReportingEvent(appAnalyticsEvent);
        }
    };
    ReportingService.prototype.fireSisfoConfirmSystemEvent = function (cartFulfillMethod) {
        var appAnalyticsEvent = {
            additionalData: __assign({ cartFulfillMethod: cartFulfillMethod, esimOrderFlag: (wlsUtils.isBYODAndEsim() || wlsUtils.isEsimFlow()) ? 1 : 0, simSwapFlag: (wlsUtils.isSimSwapFlag()) ? 1 : 0 }, this.getFormatedAdditionalDetails(false, '0', this.constructFullUrl(PageUrls.CART), undefined)),
            eventAction: this.getNewEventAction(EventTypesCodes.SYSTEM_EVENT),
            eventCode: 'DS_System_Cart_Summary_Display',
        };
        ReportingGateway_1.default.sendReportingEvent(appAnalyticsEvent);
    };
    ReportingService.prototype.isSamePage = function (url) {
        var pageInfo = this.stateManager.get('CART', 'CurrentPageURL');
        if (pageInfo && pageInfo.name && pageInfo.name === url) {
            return true;
        }
        else {
            this.stateManager.set('CurrentPageURL', { name: url });
            return false;
        }
    };
    ReportingService.prototype.getNewEventAction = function (evtType) {
        var evntAction;
        if (evtType === EventTypesCodes.FORM_SUBMIT_EVENT) {
            evntAction = EventActions.FORM_SUBMIT;
        }
        else if (evtType === EventTypesCodes.FORM_RESPONSE_EVENT) {
            evntAction = EventActions.FORM_RESPONSE;
        }
        else if (evtType === EventTypesCodes.SYSTEM_EVENT) {
            evntAction = EventActions.SYSTEM_EVENT;
        }
        return evntAction;
    };
    return ReportingService;
}(ReportingHelperService_1.default));
exports.default = ReportingService;
var EventTypesCodes;
(function (EventTypesCodes) {
    EventTypesCodes["LINK_CLICK_EVENT"] = "linkClick";
    EventTypesCodes["LINK_CLICK_EVENT_CODE"] = "Link_Click";
    EventTypesCodes["PAGE_LOAD_EVENT"] = "pageLoad";
    EventTypesCodes["PAGE_LOAD_EVENT_CODE"] = "Page_Load";
    EventTypesCodes["FORM_SUBMIT_EVENT"] = "formSubmit";
    EventTypesCodes["FORM_RESPONSE_EVENT"] = "formResponse";
    EventTypesCodes["SYSTEM_EVENT"] = "systemEvent";
    EventTypesCodes["CREDIT_CHECK_REMOVE_LINE_SYSTEM_EVENT"] = "DS_Line_Remove_Submit";
    EventTypesCodes["EMPTY_CART_SUBMIT_EVENT"] = "DS_Empty_Cart_Submit";
    EventTypesCodes["REMOVE_CART_SUBMIT_EVENT"] = "DS_Remove_Cart_Submit";
    EventTypesCodes["FUTURE_BILL_SUBMIT_EVENT"] = "DS_Cart_Future_Bill_Submit";
    EventTypesCodes["CART_UPDATE_IN_CHECKOUT_SUBMIT_EVENT"] = "DS_Cart_Update_Submit";
    EventTypesCodes["NUMBER_SELECTION_SUBMIT_USER_ACTION"] = "DS_CheckOut_LNP_Carrier_Info_Submit";
    EventTypesCodes["TRADEIN_REPORTING_EVENT"] = "DS_TradeIn_MakeModel_Selection_Submit";
    EventTypesCodes["TRADEIN_IMEI_VALIDATION_SUCCESS_EVENT"] = "DS_System_Tradein_Device_IMEI_Validation_Response";
})(EventTypesCodes = exports.EventTypesCodes || (exports.EventTypesCodes = {}));
var CheckoutLinkNames;
(function (CheckoutLinkNames) {
    CheckoutLinkNames["MODAL_CLOSE"] = "Close";
})(CheckoutLinkNames = exports.CheckoutLinkNames || (exports.CheckoutLinkNames = {}));
var PageUrls;
(function (PageUrls) {
    PageUrls["CART_PAGE"] = "/buy/cart";
    PageUrls["BUYFLOW_PRODUCT_LIST_PAGE"] = "/buy/phones";
    PageUrls["BYOD_PRODUCT_DETAILS_PAGE"] = "/buy/byod";
    PageUrls["CARTVIEW_PAGE"] = "/buy/checkout/cartview";
    PageUrls["STORE_LIST"] = "/cart/virtual/checkInStoreAvailability";
    PageUrls["TRADEIN_WORKS"] = "/buy/cart/see-how-it-tradein-works";
    PageUrls["FIRSTNET_MODAL"] = "/buy/firstnetverification/modal";
    PageUrls["FIRSTNET_IDENTITY_MODAL"] = "/buy/firstnetverification/identry/modal";
    PageUrls["IDSE_BUY_PAGE"] = "/buy";
    PageUrls["PROMO_SUB_PAGE"] = "/buy/cart/promo";
    PageUrls["REP_SUB_PAGE"] = "/buy/cart/rep";
    PageUrls["PROMO_MODAL_PAGE"] = "/cart/promo/modal";
    PageUrls["SEE_OFFER_MODAL_PAGE"] = "/buy/cart/promo/modal";
    PageUrls["SEE_YOUR_FUTURE_BILL_URL"] = "/buy/cart/futureBills/modal";
    PageUrls["IN_COMPLETE_CART_MODAL_URL"] = "/buy/cart/incompletecart/modal";
    PageUrls["CART_SEE_DETAILS_DUE_TODAY_MODAL"] = "/buy/cart/seedetailsduetoday/modal";
    PageUrls["CART_EXPRESS_SEE_DETAILS_MODAL"] = "/buy/cart/seedetailsexp/modal";
    PageUrls["CART_SEE_DETAILS_DUE_MONTHLY_MODAL"] = "/buy/cart/seedetailsduemonthly/modal";
    PageUrls["CART_SEE_DETAILS_DUE_1STBILL_MODAL"] = "/buy/cart/seedetailsduefirstbill/modal";
    PageUrls["CART_SEE_DETAILS_TAXES_FEES_MODAL"] = "/buy/cart/taxes-fees/modal";
    PageUrls["CART_SEE_DETAILS_SEASONAL_SUBSCRIPTION"] = "/buy/cart/seedetailseasonal/modal";
    PageUrls["CART_BOGO_SEE_OFFER_DETAILS_MODAL"] = "/buy/cart/bogoseeofferdetails/modal";
    PageUrls["CART_TRADEIN_NEW_MODAL"] = "/buy/cart/tradeinoffer/modal";
    PageUrls["CART_TIERED_TRADEIN_MODAL"] = "/buy/tradeindetail/modal";
    PageUrls["CART_ACCESS_FEE_HELP"] = "/buy/cart/accessfeehelp/modal";
    PageUrls["REMOVE_ALL_ITEMS_MODAL"] = "/buy/cart/removeallitems/modal";
    PageUrls["CARTEMPTY"] = "/buy/cart/emptycart";
    PageUrls["CART"] = "/buy/cart";
    PageUrls["BB_LEARN_MORE_MODAL"] = "/buy/broadband/ip-usage-learn-more/modal";
    PageUrls["RETRIEVE_CART_URL"] = "/buy/cart/retrieve/modal";
    PageUrls["SIGN_IN"] = "https://www.att.com/shop/login/login.html?retrievecart=true";
    PageUrls["SAVE_CART_URL"] = "/buy/cart/save/modal";
    PageUrls["PRIVACY_POLICY"] = "https://att.com/privacy";
    PageUrls["THANK_YOU_MODAL"] = "/buy/cart/thankyou/modal";
    PageUrls["CLOSER_COUPON_MODAL"] = "/buy/orderabandon/modal";
    PageUrls["CLOSER_MESSAGING_MODAL"] = "/buy/returntocart/modal";
    PageUrls["SEE_PAYMENT_SCHEDULE_MODAL_CART"] = "/buy/cart/paymentschedule/modal";
    PageUrls["WIRELESS_PLAN_MODAL"] = "/buy/cart/pricebreakdown/modal";
    PageUrls["MONTHLY_SAVINGS_MODAL"] = "/buy/cart/newprice/modal";
    PageUrls["SHARE_CART_MODAL"] = "/buy/cart/sharecart/modal";
    PageUrls["CART_EDIT_POPUP_URL"] = "/buy/cart/changeproductdetail/modal";
    PageUrls["CART_EDIT_COLOR_CAPACITY_URL"] = "/buy/cart/changecolorcapacity/modal";
    PageUrls["CART_LINE_SELECTION"] = "/buy/postpaid/line-selection";
    PageUrls["DS_Cart_Zipcode_Multiline_Modal"] = "/buy/cart/insurancezipmultiline/modal";
    PageUrls["DS_CHECKOUT_Zipcode_Multiline_Modal"] = "/buy/checkout/insurancezipmultiline/modal";
    PageUrls["DS_Cart_Zipcode_Mandate_Modal"] = "/buy/cart/insurancezipmandate/modal";
    PageUrls["DS_CHECKOUT_Zipcode_Mandate_Modal"] = "/buy/checkout/insurancezipmandate/modal";
    PageUrls["DS_Cart_Zipcode_Non_Mandate_Modal"] = "/buy/cart/insurancezipnonmandate/modal";
    PageUrls["INSURANCE_MODAL_URL"] = "/buy/cart/insurance/signup/modal";
    PageUrls["TRADEIN_IMEI_SELECTION_MODAL"] = "/buy/tradeindetail/devicetype/modal";
    PageUrls["TRADEIN_SKIP_IMEI"] = "/buy/tradeindetail/imei/modal";
    PageUrls["TRADEIN_CONDITION_MODAL"] = "/buy/tradeindetail/devicecondition/modal";
})(PageUrls = exports.PageUrls || (exports.PageUrls = {}));
exports.notifyFriendlyName = {
    '/buy/cart': 'DS Cart Summary Pg',
    '/buy/cart/futurebills/modal': 'DS Cart Future Bills Modal Pg',
    '/buy/cart/save/modal': 'DS Cart Save Cart Modal Pg',
    '/buy/cart/promo': 'DS Cart Promotion Pg',
    '/buy/cart/emptycart': 'DS Checkout Empty Cart Pg',
    '/buy/cart/errorcto': 'DS Cart Error CTO Pg',
    '/buy/cart/removeallitems/modal': 'DS Cart Remove All Items Modal Pg',
    '/buy/cart/retrieve/modal': 'DS Cart Retrieve Cart Modal Pg',
    '/buy/cart/seedetailsduetoday/modal': 'Ds Cart Due Today Details Modal Pg',
    '/buy/cart/seedetailsduefirstbill/modal': 'Ds Cart First Bill Due Details Modal Pg',
    '/buy/cart/multiaddressmodal': 'DS Cart Multi Address Modal Pg',
    '/buy/cart/promotions': 'DS Cart Promotion Pg',
    '/buy/cart/deliveryinfo': 'DS Checkout Express Shipping Info Pg',
    '/buy/cart/accessfeehelp/modal': 'DS Cart Access Fee Help Modal Pg',
    '/buy/cart/paymentschedule/modal': 'DS Cart Payment Schedule Modal Pg',
    '/buy/cart/sharecart/modal': 'DS Cart Sharecart Modal Pg',
    '/buy/cart/pricebreakdown/modal': 'DS Cart Pricebreakdown Modal Pg',
    '/buy/cart/changeproductdetail/modal': 'DS Cart Change Product Detail Modal Pg',
    '/buy/cart-conflict/modal': 'DS Product Details Conflict Modal Pg',
    '/buy/cart/changecolorcapacity/modal': 'DS Cart Change Color Capacity Modal Pg',
    '/buy/cart/newprice/modal': 'DS Cart New Price Modal Pg',
    '/buy/cart/taxes-fees/modal': 'DS Cart Taxes And Fees Modal Pg',
    '/buy/cart/tradeinoffer/modal': 'DS Cart TradeIn Offer Modal Pg',
    '/buy/cart/insurancezipmultiline/modal': 'DS Cart Zipcode Multiline Modal Pg',
    '/buy/checkout/insurancezipmultiline/modal': 'DS CheckOut Zipcode Multiline Modal Pg',
    '/buy/cart/insurancezipmandate/modal': 'DS Cart  Zipcode Mandate Modal Pg',
    '/buy/checkout/insurancezipmandate/modal': 'DS CheckOut Zipcode Mandate Modal Pg',
    '/buy/cart/insurancezipnonmandate/modal': 'DS Cart Zipcode Non Mandate Modal Pg',
    '/buy/cart/internet/acpmissing/modal': 'DS Cart ACP Missing Benefit Modal Pg',
    '/buy/tradeindetail/modal': 'DS Tradein  Make Model Selection Modal Pg',
    '/buy/firstnetverification/modal': 'FirstNet Verification Modal Pg',
    '/buy/firstnetverification/failed/modal': 'FirstNet Failed Verification Modal Pg',
    '/buy/firstnetverification/identry/modal': 'FirstNet ID Entry Modal Pg',
    '/buy/firstnetverification/status/modal': 'FirstNet Verification Status Modal Pg',
    '/cart/promo/modal': 'DS Cart Promo Information Modal Pg',
    '/buy/cart/promo/modal': 'DS Cart Promo Information Modal Pg',
    '/buy/tradeindetail/devicetype/modal': 'DS Tradein Make Model Selection Modal Pg',
    '/buy/tradeindetail/devicecondition/modal': 'DS Tradein Device Condition Selection Modal Pg',
    '/buy/orderabandon/modal': 'DS Order Abandon Modal Pg',
    '/buy/returntocart/modal': 'DS Return To Cart Modal Pg',
    '/buy/postpaid/line-selection': 'DS Postpaid Line Selection Pg',
    '/buy/cart/insurance/signup/modal': 'DS Cart Insurance Signup Modal Pg',
};
var ErrorTypeOption;
(function (ErrorTypeOption) {
    ErrorTypeOption["Success_Admit"] = "Success_Admit";
    ErrorTypeOption["Planned_Downtime"] = "Planned_Downtime";
    ErrorTypeOption["Failure_BusinessRule"] = "Planned_Downtime";
    ErrorTypeOption["Failure_User"] = "Failure_User";
    ErrorTypeOption["Failure_System"] = "Failure_System";
    ErrorTypeOption["Failure_Data"] = "Failure_Data";
    ErrorTypeOption["UNKNOWN"] = "";
})(ErrorTypeOption = exports.ErrorTypeOption || (exports.ErrorTypeOption = {}));
var EventActions;
(function (EventActions) {
    EventActions["PAGE_LOAD"] = "pageLoad";
    EventActions["LINK_CLICK"] = "linkClick";
    EventActions["SYSTEM_EVENT"] = "systemEvent";
    EventActions["FORM_RESPONSE"] = "formResponse";
    EventActions["FORM_SUBMIT"] = "formSubmit";
    EventActions["IMPRESSION"] = "impression";
    EventActions["MARKETING"] = "marketing";
})(EventActions = exports.EventActions || (exports.EventActions = {}));
var LinkPosition;
(function (LinkPosition) {
    LinkPosition["GLOBAL_NAV"] = "GlobalNav";
    LinkPosition["SUB_NAV"] = "SubNav";
    LinkPosition["LEFT_NAV"] = "LeftNav";
    LinkPosition["RIHGT_NAV"] = "RightNav";
    LinkPosition["BODY"] = "Body";
    LinkPosition["MARQUEE"] = "Marquee";
    LinkPosition["CAROUSEL"] = "Carousel";
    LinkPosition["TAB"] = "Tab";
    LinkPosition["LINK_FARM"] = "LinkFarm";
    LinkPosition["FOOTER"] = "Footer";
    LinkPosition["BODY_MESSAGE"] = "Body_Message";
    LinkPosition["HEADER"] = "Header";
    LinkPosition["QUICK_LINKS"] = "QuickLinks";
    LinkPosition["LINK_FARM_1"] = "LinkFarm_1";
    LinkPosition["LINK_FARM_2"] = "LinkFarm_2";
    LinkPosition["LINK_FARM_3"] = "LinkFarm_3";
    LinkPosition["BODY_ALERTS"] = "BodyAlerts";
})(LinkPosition = exports.LinkPosition || (exports.LinkPosition = {}));
var SuccessFlags;
(function (SuccessFlags) {
    /** User’s action was successful */
    SuccessFlags[SuccessFlags["SUCCESSFUL"] = 1] = "SUCCESSFUL";
    /** User’s action unsuccessful
     * (system errors, e.g. back end system down or unrecognized user input/blank fields/etc.
     */
    SuccessFlags[SuccessFlags["UNSUCCESSFUL"] = 0] = "UNSUCCESSFUL";
    /** User cancelled the action */
    SuccessFlags[SuccessFlags["USER_CANCEL"] = -1] = "USER_CANCEL";
    /** Unknown */
    SuccessFlags[SuccessFlags["UNKNOWN"] = -2] = "UNKNOWN";
})(SuccessFlags = exports.SuccessFlags || (exports.SuccessFlags = {}));
//# sourceMappingURL=ReportingService.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/api/ReportingService.js
// module id = 7
// module chunks = 8